import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type AssignmentsProductManageCurrentRoute from 'teacher-ui-client/assignments/product/manage/current/route'
import type AssignmentsProductManageCurrentController from 'teacher-ui-client/assignments/product/manage/current/controller'
import { AssignmentsTable } from 'teacher-ui-client/components/assignments-admin/assignments-table/index'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'

interface Signature {
  Args: {
    model: ModelFor<AssignmentsProductManageCurrentRoute>
    controller: AssignmentsProductManageCurrentController
  }
}
export const AssignmentsManageCurrentPage: TOC<Signature> = <template>
  <AssignmentsTable
    @subscriptionType={{@model.subscriptionType}}
    @assignments={{@controller.assignments}}
    @assignmentScores={{@model.assignmentScores}}
    @showEditAndExpireAssignment={{true}}
    @selectedAssignment={{@controller.selectedAssignment}}
    @showAssignmentAction={{@controller.showAssignment}}
    @editAssignmentAction={{@controller.editAssignment}}
    @closeAssignmentAction={{@controller.closeAssignment}}
    @openMode={{@controller.openMode}}
    @currentSortDirection={{@controller.sortDirection}}
    @currentSortColumn={{@controller.sortColumn}}
    @sortColumnAction={{@controller.sortColumnAction}}
  />
  <BasePageSelector
    class="mx-2 my-4"
    @pageCount={{@controller.totalNumOfPages}}
    @itemCount={{@model.totalAssignments}}
  />
</template>

export default RouteTemplate(AssignmentsManageCurrentPage)
